<template>
  <div class="container">
    <h3 v-html="$t('components.degraded_mode_options.heading')" />
    <h6 v-html="$t('components.degraded_mode_options.protection')" />
    <degraded-mode-prompt
      :text="$t('components.degraded_mode_options.warranty')"
      :info="$t('components.degraded_mode_options.warranty_info')"
    />
    <degraded-mode-prompt
      checkbox
      :text="$t('components.degraded_mode_options.cdw') + ' *'"
      :info="$t('components.degraded_mode_options.cdw_info')"
    />
    <div class="degraded-container">
      <degraded-mode-input
        id="degraded-cdw-1"
        :text="$t('components.degraded_mode_options.kilometers')"
        @inputchange="onKmChange"
        :value="kilometers"
      />
      <degraded-mode-input
        id="degraded-cdw-2"
        :text="$t('components.degraded_mode_options.promo_code')"
        @inputchange="onCoupon"
        :value="promoCode"
      />
    </div>
  </div>
</template>
<script>
import DegradedModePrompt from './DegradedModePrompt'
import DegradedModeInput from './DegradedModeInput'

export default {
  components: {
    DegradedModeInput,
    DegradedModePrompt,
  },
  data() {
    return {
      couponValue: null,
      kmValue: null,
    }
  },
  watch: {
    promoCode: {
      handler(val) {
        if (!val) {
          return
        }
        this.couponValue = val
      },
    },
    kilometers: {
      handler(val) {
        if (!val) {
          return
        }
        this.kmValue = val
      },
    },
  },
  computed: {
    promoCode() {
      if (window.renaultRent?.sessions?.promoCode === null) {
        return ''
      }
      return window.renaultRent?.sessions?.promoCode
    },
    kilometers() {
      if (window.renaultRent?.sessions?.kilometers === null) {
        return ''
      }
      return window.renaultRent?.sessions?.kilometers
    },
  },
  methods: {
    onKmChange() {
      this.$store.commit('quotation/SET_KM', this.kmValue)
    },
    onCoupon() {
      this.$store.commit('quotation/SET_COUPON', this.couponValue)
    },
  },
}
</script>
<style lang="scss" scoped>

div {
  background: $c-alabaster;
  padding-bottom: 20px;
  width: 100%;
}

.container {
  padding: 20px;
}

.degraded-container {
  display: flex;
  flex-direction: column;
  width: 100%;

  @include teq-breakpoint($large) {
    width: 50%;
  }
}

</style>
